import React from 'react'

import { type CustomerAttributeGroup } from '~/hooks/useSurveyQuery'
import { pathAssume } from '~/utils'

import { useCustomerAttributesData } from '../hooks/useCustomerAttributesData'

import { IndividualChart, type IndividualChartProps } from './IndividualChart'

export type IndividualCustomerAttributeChartProps = {
  customerAttributeGroup: CustomerAttributeGroup
}

export const IndividualCustomerAttributeChart = ({
  customerAttributeGroup,
}: IndividualCustomerAttributeChartProps) => {
  const customerAttributesData = useCustomerAttributesData(
    customerAttributeGroup,
  )
  const individualChartProps = React.useMemo<
    IndividualChartProps<(typeof customerAttributesData)[number]>
  >(
    () => ({
      getChartCategoryAxisItemLabel: (value) =>
        7 < value.length ? `${value.slice(0, 6)}...` : value,
      getName: pathAssume('customerAttribute.name'),
      getRowId: pathAssume('customerAttribute.id'),
      id: customerAttributeGroup.id,
      rowsData: customerAttributesData,
    }),
    [customerAttributeGroup.id, customerAttributesData],
  )

  return <IndividualChart {...individualChartProps} />
}
